import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';

interface CommonProps {
  isDisabled: boolean;
  text: string;
}

type Props = CommonProps & {
  onClick: Function;
};

const AddButton = ({ ...props }: Props) => {
  return (
    <Styled
      onClick={() => {
        props.onClick();
      }}
      disabled={props.isDisabled}
    >
      <span className="icon">
        <img src="/images/icon/add-blue.png" alt="追加する" />
      </span>
      <span className="text">{props.text}</span>
    </Styled>
  );
};

const Styled = styled.div<{ disabled: boolean }>`
  width: 170px;
  position: relative;
  padding: 6px 12px;
  border-radius: 4px;
  background-color: ${({ disabled }) =>
    disabled ? StyleConfig.COLOR.BTN_DISABLED : StyleConfig.COLOR.PRIMARY};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  .icon {
    width: 20px;
    margin-right: ${StyleConfig.HELPER.M8};
  }
  .text {
    color: #fff;
    font-size: 12px;
  }
`;
export default AddButton;
